import { render, staticRenderFns } from "./add_goods.vue?vue&type=template&id=205498c4&scoped=true"
import script from "./add_goods.vue?vue&type=script&lang=js"
export * from "./add_goods.vue?vue&type=script&lang=js"
import style0 from "./add_goods.vue?vue&type=style&index=0&id=205498c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205498c4",
  null
  
)

export default component.exports